import {
  Heart, Sparkles, Briefcase, PartyPopper, Plane, Camera, Cake, Wine,
} from "lucide-react";

export const OCCASIONS = [
  { id: "Wedding", label: "Wedding", icon: Heart, tint: "#FDF1F0" },
  { id: "Date Night", label: "Date Night", icon: Wine, tint: "#F5EEF6" },
  { id: "Interview", label: "Interview", icon: Briefcase, tint: "#EDF1F6" },
  { id: "Festival", label: "Festival", icon: PartyPopper, tint: "#FBF0E8" },
  { id: "Vacation", label: "Vacation", icon: Plane, tint: "#EAF2F0" },
  { id: "Photoshoot", label: "Photoshoot", icon: Camera, tint: "#F0EDF6" },
  { id: "Birthday", label: "Birthday", icon: Cake, tint: "#FDF1F0" },
  { id: "Office Party", label: "Office Party", icon: Sparkles, tint: "#F5EEF6" },
];

// Curated imagery pools assigned to AI-generated items by index/category
export const HAIR_IMAGES = [
  "https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1522337660859-02fbefca4d79?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1519699047748-de8e457a634e?auto=format&fit=crop&w=600&q=80",
];

export const OUTFIT_IMAGES = {
  Outfit: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=600&q=80",
  Shoes: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&w=600&q=80",
  Watch: "https://images.unsplash.com/photo-1524805444758-089113d48a6d?auto=format&fit=crop&w=600&q=80",
  Bag: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&w=600&q=80",
  Sunglasses: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&w=600&q=80",
  Perfume: "https://images.unsplash.com/photo-1541643600914-78b084683601?auto=format&fit=crop&w=600&q=80",
};

export const COSMETIC_IMAGES = {
  "Face Cleanser": "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=600&q=80",
  "Hair Serum": "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?auto=format&fit=crop&w=600&q=80",
  "Beard Oil": "https://images.unsplash.com/photo-1621607512214-68297480165e?auto=format&fit=crop&w=600&q=80",
  "Moisturizer": "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&w=600&q=80",
  "Lip Care": "https://images.unsplash.com/photo-1586495777744-4413f21062fa?auto=format&fit=crop&w=600&q=80",
  "Styling Gel": "https://images.unsplash.com/photo-1631730359585-38a4935cbec4?auto=format&fit=crop&w=600&q=80",
};

export const ACCESSORY_IMAGES = {
  Watch: "https://images.unsplash.com/photo-1524805444758-089113d48a6d?auto=format&fit=crop&w=600&q=80",
  Bag: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&w=600&q=80",
  Clutch: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&w=600&q=80",
  Sunglasses: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&w=600&q=80",
  Perfume: "https://images.unsplash.com/photo-1541643600914-78b084683601?auto=format&fit=crop&w=600&q=80",
  Jewelry: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=600&q=80",
  Belt: "https://images.unsplash.com/photo-1624222247344-550fb60583dc?auto=format&fit=crop&w=600&q=80",
  Shoes: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&w=600&q=80",
  Bracelet: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=600&q=80",
  Wallet: "https://images.unsplash.com/photo-1627123424574-724758594e93?auto=format&fit=crop&w=600&q=80",
};

// Stable apparel/footwear imagery for shopping/product cards
export const APPAREL_IMAGES = {
  top: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=600&q=80",
  bottom: "https://images.pexels.com/photos/52518/jeans-pants-blue-shop-52518.jpeg?auto=compress&cs=tinysrgb&w=600",
  mascShoes: "https://images.pexels.com/photos/292999/pexels-photo-292999.jpeg?auto=compress&cs=tinysrgb&w=600",
  femShoes: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&w=600&q=80",
};

// Robust category -> image picker based on keyword matching (+ gender-aware footwear)
export function pickImage(category = "", kind = "outfit", direction = "androgynous") {
  const c = category.toLowerCase();
  const has = (...k) => k.some((x) => c.includes(x));
  if (has("watch")) return ACCESSORY_IMAGES.Watch;
  if (has("sunglass", "eyewear")) return ACCESSORY_IMAGES.Sunglasses;
  if (has("perfume", "fragrance", "cologne", "oud", "eau")) return ACCESSORY_IMAGES.Perfume;
  if (has("jewel", "earring", "necklace", "bangle", "ring", "chain", "kada")) return ACCESSORY_IMAGES.Jewelry;
  if (has("belt")) return ACCESSORY_IMAGES.Belt;
  if (has("bracelet")) return ACCESSORY_IMAGES.Bracelet;
  if (has("wallet")) return ACCESSORY_IMAGES.Wallet;
  if (has("shoe", "heel", "loafer", "sneaker", "footwear", "pump", "sandal", "mojari", "jutti", "brogue", "oxford", "derby", "boot"))
    return direction === "feminine" ? APPAREL_IMAGES.femShoes : APPAREL_IMAGES.mascShoes;
  if (has("bag", "clutch", "handbag", "purse", "pocket square")) return ACCESSORY_IMAGES.Bag;
  if (has("bottom", "trouser", "pant", "churidar", "skirt", "jeans", "chino", "palazzo", "dhoti", "salwar", "legging", "shorts"))
    return APPAREL_IMAGES.bottom;
  if (has("top", "shirt", "kurta", "kurti", "sherwani", "bandhgala", "blazer", "jacket", "gown", "dress", "saree", "sari", "lehenga", "anarkali", "tunic", "overshirt", "co-ord", "suit", "tuxedo", "nehru", "waistcoat"))
    return APPAREL_IMAGES.top;
  if (has("cleanser")) return COSMETIC_IMAGES["Face Cleanser"];
  if (has("serum")) return COSMETIC_IMAGES["Hair Serum"];
  if (has("beard")) return COSMETIC_IMAGES["Beard Oil"];
  if (has("moistur")) return COSMETIC_IMAGES["Moisturizer"];
  if (has("lip")) return COSMETIC_IMAGES["Lip Care"];
  if (has("gel", "clay", "cream", "spray", "fixer", "styling", "wax")) return COSMETIC_IMAGES["Styling Gel"];
  return kind === "accessory" ? APPAREL_IMAGES.top : OUTFIT_IMAGES.Outfit;
}

// Distinct, verified full-look fashion images so every outfit card differs
export const OUTFIT_LOOK_IMAGES = {
  masculine: [
    "https://images.unsplash.com/photo-1516257984-b1b4d707412e?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1520975954732-35dd22299614?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1488161628813-04466f872be2?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1503341504253-dff4815485f1?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=800&q=75",
  ],
  feminine: [
    "https://images.unsplash.com/photo-1595777457583-95e059d581b8?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?auto=format&fit=crop&w=800&q=75",
    "https://images.unsplash.com/photo-1502716119720-b23a93e5fe1b?auto=format&fit=crop&w=800&q=75",
  ],
};
OUTFIT_LOOK_IMAGES.androgynous = [
  OUTFIT_LOOK_IMAGES.masculine[0], OUTFIT_LOOK_IMAGES.feminine[0],
  OUTFIT_LOOK_IMAGES.masculine[2], OUTFIT_LOOK_IMAGES.feminine[2],
  OUTFIT_LOOK_IMAGES.masculine[4], OUTFIT_LOOK_IMAGES.feminine[4],
];

export function pickOutfitImage(index = 0, direction = "androgynous") {
  const key = direction === "feminine" ? "feminine" : direction === "masculine" ? "masculine" : "androgynous";
  const pool = OUTFIT_LOOK_IMAGES[key];
  return pool[index % pool.length];
}

const STORE_LINKS = {
  Zara: "https://www.zara.com",
  Myntra: "https://www.myntra.com",
  Ajio: "https://www.ajio.com",
  Amazon: "https://www.amazon.com",
  "H&M": "https://www2.hm.com",
};

export function storeLink(store) {
  return STORE_LINKS[store] || "https://www.google.com/search?q=" + encodeURIComponent(store || "shop");
}

// Fallback data so the experience always completes even if AI is unavailable
export const FALLBACK_ANALYSIS = {
  faceShape: "Oval",
  hairTexture: "Wavy",
  skinTone: "Warm Beige",
  beardStatus: "Light Stubble",
  styleVibe: "Refined Minimalist",
  confidence: 92,
  notes: "Balanced proportions suit soft, structured styling.",
};

export const FALLBACK_RECOMMENDATIONS = {
  styleDirection: "androgynous",
  plan: [
    "Cleanse & prep skin the night before",
    "Book styling 2 hours ahead",
    "Steam outfit and polish shoes",
    "Hydrate and rest for a fresh glow",
  ],
  hairstyles: [
    { name: "Textured Layers", reason: "Adds movement and balances most face shapes for the occasion.", confidence: 94, services: ["Cut", "Texturizing", "Blow-dry"], maintenance: "Medium", time: "45 min" },
    { name: "Slick Minimal Style", reason: "Clean, polished and effortlessly refined for any setting.", confidence: 90, services: ["Cut", "Styling"], maintenance: "Low", time: "30 min" },
    { name: "Short Crop", reason: "Sharp, modern and low-effort with a premium finish.", confidence: 88, services: ["Cut", "Finish"], maintenance: "Low", time: "35 min" },
  ],
  outfits: [
    { category: "Outfit", name: "Tailored Co-ord Set", price: "$180", store: "Zara", reason: "Sharp and occasion-ready silhouette.", palette: "Ivory & Stone" },
    { category: "Layer", name: "Structured Overshirt", price: "$95", store: "H&M", reason: "Adds polish without bulk.", palette: "Warm Beige" },
    { category: "Footwear", name: "Minimal Leather Shoes", price: "$120", store: "Ajio", reason: "Elegant grounding piece.", palette: "Tan" },
    { category: "Bottom", name: "Pleated Trousers", price: "$85", store: "Myntra", reason: "Refined drape and comfort.", palette: "Charcoal" },
  ],
  accessories: [
    { category: "Watch", name: "Minimal Steel Watch", price: "$220", store: "Amazon" },
    { category: "Sunglasses", name: "Tortoise Acetate Frames", price: "$70", store: "Myntra" },
    { category: "Bag", name: "Compact Crossbody", price: "$95", store: "Ajio" },
    { category: "Perfume", name: "Soft Amber Eau de Parfum", price: "$85", store: "Amazon" },
  ],
  cosmetics: [
    { category: "Face Cleanser", name: "Gentle Glow Cleanser", price: "$18", benefit: "Fresh, clean base" },
    { category: "Hair Serum", name: "Silk Shine Serum", price: "$24", benefit: "Frizz-free shine" },
    { category: "Styling Cream", name: "Flexible Styling Cream", price: "$16", benefit: "Natural hold" },
    { category: "Moisturizer", name: "Dewy Hydra Cream", price: "$28", benefit: "All-day hydration" },
    { category: "Lip Care", name: "Rose Tint Balm", price: "$12", benefit: "Nourished lips" },
    { category: "Perfume", name: "Signature Eau de Parfum", price: "$85", benefit: "Lasting elegance" },
  ],
};

export const FALLBACK_CONTENT = {
  instagramCaption: "New occasion, new energy. Styled end-to-end by HOH AI. Feeling like the best version of me ✨",
  whatsappStatus: "Fresh look, main-character energy.",
  linkedinPost: "Preparation meets confidence. Grateful for tools that help me show up as my best self for the moments that matter.",
  reelScript: "Scene 1: The before.\nScene 2: The HOH AI reveal.\nScene 3: Ready for the moment.",
  hashtags: ["#HOHAI", "#OccasionReady", "#StyleOS", "#AIStylist", "#GetTheLook", "#Glow"],
  getTheLookText: "This complete look was designed by HOH AI for your occasion. Tap Get The Look to shop every piece in one place.",
};

export const FALLBACK_CONCEPTS = [
  {
    tier: "Classic & Safe", name: "Timeless Formal", occasion: "Occasion",
    description: "A refined, fail-safe silhouette that always looks put-together.",
    topWear: "Tailored White Shirt", bottomWear: "Charcoal Trousers", footwear: "Leather Derby Shoes",
    accessories: ["Steel Watch", "Leather Belt", "Subtle Cologne"],
    colorPalette: "White · Charcoal · Tan", fabric: "Cotton & Wool Blend",
    estimatedBudget: "₹9,500", confidence: 92,
  },
  {
    tier: "Premium & Luxury", name: "Signature Luxe", occasion: "Occasion",
    description: "Elevated fabrics and statement detailing for a premium presence.",
    topWear: "Structured Blazer", bottomWear: "Pleated Wool Trousers", footwear: "Suede Loafers",
    accessories: ["Luxury Watch", "Silk Pocket Square", "Oud Perfume"],
    colorPalette: "Navy · Ivory · Gold", fabric: "Italian Wool",
    estimatedBudget: "₹24,000", confidence: 96,
  },
  {
    tier: "Trendy & Fashion Forward", name: "Modern Edit", occasion: "Occasion",
    description: "Contemporary cuts and bold accents for a fashion-forward statement.",
    topWear: "Oversized Textured Overshirt", bottomWear: "Tapered Cargo Trousers", footwear: "Chunky Sneakers",
    accessories: ["Minimal Chain", "Tinted Sunglasses", "Fresh Eau de Parfum"],
    colorPalette: "Stone · Sage · Black", fabric: "Linen Blend",
    estimatedBudget: "₹14,000", confidence: 90,
  },
];

export const FALLBACK_SHOPPING = {
  groups: [
    { category: "Top Wear", query: "Tailored Shirt", products: [
      { name: "Slim Fit Formal Shirt", brand: "Van Heusen", price: "₹1,799", store: "Myntra", rating: 4.3, buyLink: "https://www.google.com/search?q=Slim+Fit+Formal+Shirt+site:myntra.com" }] },
    { category: "Bottom Wear", query: "Formal Trousers", products: [
      { name: "Slim Fit Trousers", brand: "Arrow", price: "₹2,199", store: "AJIO", rating: 4.2, buyLink: "https://www.ajio.com/search/?text=Slim+Fit+Trousers" }] },
    { category: "Footwear", query: "Leather Shoes", products: [
      { name: "Leather Derby Shoes", brand: "Clarks", price: "₹4,999", store: "Amazon India", rating: 4.5, buyLink: "https://www.amazon.in/s?k=Leather+Derby+Shoes" }] },
  ],
};

export const BOOKING_DEFAULTS = {
  salon: "Maison Lumière Studio",
  stylist: "Aria Sen — Senior Stylist",
  services: ["Hair Styling", "Grooming", "Look Finishing"],
  price: "₹5,500",
};
